import Button from "../core/Button";
import Strings from "../core/data/Strings";
import { GameObject } from "../core/GameObject";
import ScaleManager from "../core/ScaleManager";
import GameColors from "../GameColors";
import { GameScene } from "../scenes/GameScene";
import Fonts from "../utils/Fonts";
import LayoutUtils from "../utils/LayoutUtils";
import TweenUtils from "../utils/TweenUtils";

export class HowToPlayScreen extends GameObject {

	resize: () => void;
	static isOpen: boolean;
	private _onExit: () => void;
	constructor(scene: GameScene, onExit?:() => void) {
		super(scene);
		HowToPlayScreen.isOpen = true;
		const bg = this.addImage("shopBaseBG");
		this._onExit = onExit;
		const starBurstSpine = scene.add.spine(0, 0, "star-burst", "starburst-idle", true);
        const starBurst = scene.add.spineContainer(0, 0, starBurstSpine);
        this.add(starBurst);
		const popup = scene.add.container();
		this.add(popup);

		const popBG = this.addImage("helpBG");
		const leftGlow = this.addImage("shopBGGlow");
		const rightGlow = this.addImage("shopBGGlow");

		const headerGroup = scene.add.container();
		const header = this.addImage("headerYellow")
		const headerStyle = {
			fontFamily: Fonts.LuckiestGuy,
			color: "#ffeddf",
			fontSize: "75px",
			fontStyle: 'normal',
			stroke: "#58381b",
			strokeThickness: 3,
		}
		const headerText = scene.add.text(0, 0, Strings.get("HowToPlay"), headerStyle);
		headerText.setShadow(5, 5, GameColors.BLACK, 1, false, true);
		headerGroup.setSize(header.width, header.height);
		headerGroup.add([header, headerText]);

		const style: Phaser.Types.GameObjects.Text.TextStyle = {
			fontFamily: Fonts.MaliMediumItalic,
			color: "#583306",
			fontSize: "24px",
			align: "center",
			wordWrap: { width: 340, useAdvancedWrap: true }
		};

		const style2: Phaser.Types.GameObjects.Text.TextStyle = {
			fontFamily: Fonts.LuckiestGuy,
			// color: GameColors.WHITE,
			fontSize: "42px",
			align: "center",
			wordWrap: { width: 350 }
		};

		// const platform = this.scene.game.device.os.desktop ? 'Web' : 'Mobile';
		const platform = this.scene.game.device.input.touch ? 'Mobile' : 'Web';
		const group1 = scene.add.container();
		const group2 = scene.add.container();
		const group3 = scene.add.container();
		const group4 = scene.add.container();
		const groups = [group1, group2, group3, group4];

		const img1 = scene.add.image(0, 0, "helpImgWeb1" + platform);
		const text1 = scene.add.text(0, 0, Strings.get("TutorialText1" + platform), style);
		const img2 = scene.add.image(0, 0, "helpImgWeb2" + platform);
		const text2 = scene.add.text(0, 0, Strings.get("TutorialText2" + platform), style);
		const img3 = scene.add.image(0, 0, "helpImgWeb3")
		const text3 = scene.add.text(0, 0, Strings.get("TutorialText3" + platform), style);
		const img4 = scene.add.image(0, 0, "helpImgWeb4");
		const text4 = scene.add.text(0, 0, Strings.get("TutorialText4" + platform), style);

		const label1 = scene.add.text(0, 0, Strings.get("Label1"), style2);
		const label2 = scene.add.text(0, 0, Strings.get("Label2"), style2);
		const label3 = scene.add.text(0, 0, Strings.get("Label3"), style2);
		const label4 = scene.add.text(0, 0, Strings.get("Label4"), style2);
		label1.setShadow(5, 5, GameColors.BLACK, 1, false, true);
		label2.setShadow(5, 5, GameColors.BLACK, 1, false, true);
		label3.setShadow(5, 5, GameColors.BLACK, 1, false, true);
		label4.setShadow(5, 5, GameColors.BLACK, 1, false, true);
		const labels = [label1, label2, label3, label4];
		for (const label of labels) {
			label.setOrigin(0.5);
			LayoutUtils.scaleToMaxWidth(label, 250);
		}

		group1.setSize(img1.width, img1.height);
		group2.setSize(img2.width, img2.height);
		group3.setSize(img3.width, img3.height);
		group4.setSize(img4.width, img4.height);

		group1.add([img1, text1, label1]);
		group2.add([img2, text2, label2]);
		group3.add([img3, text3, label3]);
		group4.add([img4, text4, label4]);
		const okGroup = scene.add.container();
		const okBtn = scene.add.button(0, 0, "okButton", undefined, this.exit, this, true)
		const okText = scene.add.text(0, 0, Strings.get("Ok"), headerStyle);
		okGroup.setScale(okBtn.width, okBtn.height);
		okGroup.add([okBtn, okText]);
		okBtn.addPointerDownAnim(TweenUtils.ButtonBounceWithText(scene, okBtn, okText));

		const soundOn = !this.scene.soundManager.muted;
		const soundButtonKey = soundOn ? "soundButtonOn" : "soundButtonOff";
		const soundButton = scene.add.button(0, 0, soundButtonKey, undefined, () => this.toggleSound(soundButton), undefined, true);
		this.add(soundButton)

		popup.add([leftGlow, rightGlow, popBG, headerGroup, group1, group2, group3, group4, okGroup]);

		this.resize = () => {
			ScaleManager.ScaleBackgroundFromZone(bg, scene.viewport);
			scene.alignIn.Center(bg, scene.viewport)
			const scale = Math.min(scene.viewport.width / (popBG.width + 100), 1);
			popup.scale = scale;
			scene.alignIn.Center(starBurst, scene.viewport, 0, 0);
			scene.alignIn.Center(popup, scene.viewport, 0, 60);
			scene.alignIn.Center(leftGlow, popBG, -popBG.displayWidth / 2 + 300);
			scene.alignIn.Center(rightGlow, popBG, popBG.displayWidth / 2 - 300);
			scene.alignTo.TopCenter(headerGroup, popBG, 0, 10);
			scene.alignIn.Center(headerText, header, 0, -13);
			scene.alignIn.BottomCenter(okGroup, popBG, 10, -15);
			scene.alignIn.Center(okText, okBtn, 0, -10);
			scene.alignIn.Center(group1, popBG, -img1.width * 1.5 - 10, -20);
			scene.alignIn.Center(group2, popBG, -img1.width * 0.5 - 5, -20);
			scene.alignIn.Center(group3, popBG, img1.width * 0.5 + 5, -20);
			scene.alignIn.Center(group4, popBG, img1.width * 1.5 + 10, -20);
			scene.alignIn.Center(text1, img1, 0, 80 + text1.displayHeight / 2);
			scene.alignIn.Center(text2, img2, 0, 80 + text2.displayHeight / 2);
			scene.alignIn.Center(text3, img3, 0, 80 + text3.displayHeight / 2);
			scene.alignIn.Center(text4, img4, 0, 80 + text4.displayHeight / 2);
			scene.alignIn.TopCenter(label1, img1, 0, -21);
			scene.alignIn.TopCenter(label2, img2, 0, -18);
			scene.alignIn.TopCenter(label3, img3, 0, -20);
			scene.alignIn.TopCenter(label4, img4, 0, -18);
			scene.alignIn.TopRight(soundButton, scene.viewport, -34, -34);
		}

		scene.addResize(this.resize);

		// Tween in ---------
		popBG.setScale(0);
		soundButton.setScale(0);
		okGroup.setScale(0);
		headerGroup.y -= 300;
		group1.y += scene.viewport.height;
		group2.y += scene.viewport.height;
		group3.y += scene.viewport.height;
		group4.y += scene.viewport.height;


		scene.tweens.add({
			targets: popBG,
			scale: 1,
			ease: Phaser.Math.Easing.Back.Out,
			duration: 200,
		});

		scene.tweens.add({
			targets: headerGroup,
			y: headerGroup.y + 300,
			ease: Phaser.Math.Easing.Back.Out,
			duration: 300,
			delay: 100,
			onStart: () => {
				for (let i = 0; i < 4; i++) {
					scene.tweens.add({
						targets: groups[i],
						y: groups[i].y - scene.viewport.height,
						ease: Phaser.Math.Easing.Back.Out,
						duration: 300,
						delay: 50 * i,
					});
				}

				scene.tweens.add({
					targets: [soundButton, okGroup],
					scale: 1,
					ease: Phaser.Math.Easing.Back.Out,
					duration: 300,
				});
			}
		});
	}

	destroy(): void {
		this.scene.removeResize(this.resize);
		super.destroy();
	}

	exit(): void {
		if(this._onExit) this._onExit.call(this._onExit);
		HowToPlayScreen.isOpen = false;
		this.destroy();
	}

	toggleSound(btn: Button): void {
		this.scene.soundManager.muted = !this.scene.soundManager.muted;
		this.scene.sound.mute = this.scene.soundManager.muted;
		this.scene.music.muted = !this.scene.music.muted;
		if (!this.scene.soundManager.muted) btn.setTexture("soundButtonOn");
		else btn.setTexture("soundButtonOff");
	}
}